import script from "./DependentProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./DependentProfile.vue?vue&type=script&setup=true&lang=js"

import "./DependentProfile.vue?vue&type=style&index=0&id=726e989e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726e989e"]])

export default __exports__